import { Hero } from '@/ui';
import { HeroComponentFields } from '@types';

import { BlockBase, getMarginClassNames } from '../utils';
import { transformBannerData } from './transform-banner-data';

export type BannerBlockProps = HeroComponentFields & BlockBase;

export function Banner({ params, slides, id, margin, ...rest }: BannerBlockProps) {
  const convertedSlides = slides?.map((slide) => {
    return transformBannerData({ ...slide, params, id });
  });

  return <Hero {...rest} id={id} className={getMarginClassNames(margin)} slides={convertedSlides} />;
}
